import { jsx as _jsx } from "react/jsx-runtime";
export const LimitedContent = ({ children, maxRows = 1, }) => {
    const style = {
        display: '-webkit-box',
        overflow: 'hidden',
        WebkitLineClamp: maxRows,
        WebkitBoxOrient: 'vertical',
    };
    return _jsx("div", { style: style, children: children });
};
